import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RevealContentStates } from './reveal-content.constants';
import { CommonModule } from '@angular/common';
import { FontIconComponent } from '../font-icon/font-icon.component';
import { ButtonComponent } from '../button/button.component';

@Component({
    selector: 'finder-reveal-content',
    templateUrl: './reveal-content.component.html',
    styleUrls: ['./reveal-content.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FontIconComponent,
        ButtonComponent,
    ]
})
export class RevealContentComponent implements OnInit {

    @Input() showMoreText: string;
    @Input() showLessText: string;
    @Input() state: RevealContentStates = RevealContentStates.MORE;
    @Output() currentState: EventEmitter<RevealContentStates> = new EventEmitter();

    displayText: string;
    showMoreArrow: boolean;
    showLessArrow: boolean;

    private status: RevealContentStates;

    constructor() { }

    ngOnInit() {
        // Set the initial state
        this.status = this.state;
        // Update display
        this.updateDisplayText();
        this.updateArrows();
    }

    /**
     * @name            toggleState
     * @description     Toggle the state of the component
     */
    toggleState() {
        // Toggle the state
        this.status = this.status === RevealContentStates.MORE ? RevealContentStates.LESS : RevealContentStates.MORE;

        // Set the text
        this.updateDisplayText();

        // Update the arrows
        this.updateArrows();

        // Broadcast the state
        this.currentState.emit(this.status);
    }

    /**
     * @name            toggleDisplayText
     * @description     Update the text on the component
     */
    private updateDisplayText() {
        // Set display text
        this.displayText = this.status === RevealContentStates.MORE ? this.showMoreText : this.showLessText;
    }

    /**
     * @name            updateArrows
     * @description     Updates the arrow states in the component
     */
    private updateArrows() {
        if (this.status === RevealContentStates.MORE) {
            this.showLessArrow = false;
            this.showMoreArrow = true;
        } else {
            this.showLessArrow = true;
            this.showMoreArrow = false;
        }
    }

}
